import { Route, Routes } from 'react-router-dom';

import { WebPageType } from '../constants/webPageType';
import CloudStorageScreen from '../screens/AccountSetting/CloudStorage';
import GetMoreBreadScreen from '../screens/AccountSetting/GetMoreBread';
import NotEnoughStorageScreen from '../screens/AccountSetting/NotEnoughStorage';
import SubscriptionScreen from '../screens/AccountSetting/Subscription';
import WalletScreen from '../screens/AccountSetting/Wallet';
import AddToHomeGuideScreen from '../screens/Auth/AddToHomeGuide';
import AppMainScreen from '../screens/Auth/AppMain';
// import CreditsPaymentScreen from '../screens/Auth/CreditsPayment';
import EmailVerificationScreen from '../screens/Auth/EmailVerification';
import EntryScreen from '../screens/Auth/Entry';
import ForgotPasswordScreen from '../screens/Auth/ForgotPassword';
import HomeScreen from '../screens/Auth/Home';
import LoginScreen from '../screens/Auth/Login';
import NotFound from '../screens/Auth/NotFound';
import RegisterScreen from '../screens/Auth/Register';
import ResetPasswordScreen from '../screens/Auth/ResetPassword';
import SuccessRegScreen from '../screens/Auth/SuccessReg';
import TrialScreen from '../screens/Auth/Trial';
import TTSEnhancementScreen from '../screens/Auth/TTSEnhancement';
import { DebugScreen } from '../screens/Debug/DebugScreen';
const AuthRoute: React.FC = () => {
  const isDevEnvOnly = process.env.NODE_ENV === 'development';

  // const userId = useSessionStore((state) => state.activeUserId);
  // const userAccount = useUserStore((state) => state.getAccount(userId ?? ''));
  // const isPurchased = userAccount?.hasAnyPurchased;

  return (
    <Routes>
      <Route path="/" element={<AppMainScreen />} />
      {isDevEnvOnly && <Route path="/home" element={<HomeScreen />} />}
      {isDevEnvOnly && <Route path="/debug" element={<DebugScreen />} />}
      <Route
        path="/start"
        element={<EntryScreen webPageType={WebPageType.JOYAJOY} />}
      />
      <Route
        path="/register"
        element={
          <RegisterScreen
            webPageType={WebPageType.JOYAJOY}
            isPhoneSignup={false}
          />
        }
      />
      {/* <Route
        path="/register-with-email"
        element={<RegisterScreen isPhoneSignup={false} />}
      /> */}
      {/* <Route path='/verify-phone' element={} */}
      <Route
        path="/register/success"
        element={<SuccessRegScreen webPageType={WebPageType.JOYAJOY} />}
      />
      <Route
        path="/login"
        element={<LoginScreen webPageType={WebPageType.JOYAJOY} />}
      />
      <Route
        path="/trial"
        element={<TrialScreen webPageType={WebPageType.JOYAJOY} />}
      />
      <Route
        path="/forgot-password"
        element={<ForgotPasswordScreen webPageType={WebPageType.JOYAJOY} />}
      />
      <Route path="/verify" element={<EmailVerificationScreen />} />
      <Route
        path="/reset-password"
        element={<ResetPasswordScreen webPageType={WebPageType.JOYAJOY} />}
      />
      {/* <Route path="/credit-payment" element={<CreditsPaymentScreen />} /> */}
      <Route path="/tts-enhancement" element={<TTSEnhancementScreen />} />
      <Route path="/add-to-home-guide" element={<AddToHomeGuideScreen />} />
      <Route path="/wallet" element={<WalletScreen />} />
      <Route path="/cloud-storage" element={<CloudStorageScreen />} />
      <Route path="/subscription" element={<SubscriptionScreen />} />
      <Route path="/get-more-bread" element={<GetMoreBreadScreen />} />
      <Route path="/not-enough-storage" element={<NotEnoughStorageScreen />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
};

export default AuthRoute;
